/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_InviteInputs */

const zh_share_invite = /** @type {(inputs: Share_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邀请`)
};

const en_share_invite = /** @type {(inputs: Share_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite`)
};

const es_share_invite = /** @type {(inputs: Share_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitar`)
};

/**
* | output |
* | --- |
* | "Invite" |
*
* @param {Share_InviteInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const share_invite = /** @type {((inputs?: Share_InviteInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_InviteInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_share_invite(inputs)
	if (locale === "en") return en_share_invite(inputs)
	return es_share_invite(inputs)
});